export const CALENDAR_LEGEND = [
  { label: 'In person', className: 'bg-blue-300' },
  { label: 'Virtual', className: 'bg-blue-200' },
  { label: 'Birthday', className: 'bg-status-success' },
  { label: 'Task Deadline', className: 'bg-neutral-400' },
  { label: 'Task Reminder', className: 'bg-red-500' },
] as const;
